
export class RadFilePathModel {
    
    FilePath: string;
    FileName: string;
    FileExe: string;
    mainName: string;

    constructor(
        FilePath: string,
        FileName: string,
        FileExe: string,
        mainName: string
    ) {
        this.FilePath = FilePath;
        this.FileName = FileName;
        this.FileExe = FileExe;
        this.mainName = mainName;
    }

    public static fromJson(json: any): RadFilePathModel {
        return new RadFilePathModel(
            json["FilePath"],
            json["FileName"],
            json["FileExe"],
            json["mainName"]
        );
    }
}